<template>
  <el-dialog title="部分移库确认" :visible.sync="partSureShow" width="30%" :before-close="cancel">
    <el-alert :closable="false" type="error">
      <div slot="title" style="font-size: 16px;color: red; text-align: left;">请确认数量，如移库数量正确，请重新生成批次并贴在本次对应的商品上</div>
    </el-alert>
    <div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="pkgCode" label="批次"></el-table-column>
        <el-table-column prop="amount" label="批次数量"></el-table-column>
        <el-table-column prop="moveNum" label="本次移库数量"></el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="ok">
        确认并生成批次
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import { transferPkgSpilt } from "@/apis/inHouse"
export default {
  data() {
    return { partSureShow: false, tableData: [] }
  },
  props: {
  },
  components: {
  },
  methods: {
    showMovePart(data) {
      this.tableData = data;
      this.partSureShow = true
    },
    cancel() {
      this.$emit("cancel", this.tableData)
      this.partSureShow = false
    },
    // 确定点击
    async ok() {
      const data = this.tableData[0]
      const { pkgCode, moveNum: transferAmount } = data
      const res = await transferPkgSpilt({
        pkgCode,
        transferAmount
      });
      if (res.code === 0) {
        this.$wmsPrint.print().templatePrintByPkg([{ ...data, pkgCode: res.data?.pkgCode }])
      }
      this.partSureShow = false
      this.$emit('ok', { ...res.data, originData: pkgCode })
    }
  }
}
</script>

<style scoped>
:v-deep .tips {
  text-align: left;
}
</style>